function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.472 9.73c-.027 5.89.025 17.272 0 23.162 0 1.453-1.293 2.626-2.89 2.626H7.202c-1.592 0-2.89-1.172-2.89-2.625V11.16c0-1.45 1.298-2.627 2.89-2.627h40.805z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.796 18.293h4.92v4.864h-4.92zm9.574.13h4.808v4.743H39.37zM9.725 26.7h4.408v4.522H9.725z",
  className: "icon-secondary",
  fill: "#adb9ca"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.873 8.402c0-1.53.932-2.777 2.075-2.777 1.15 0 2.075 1.247 2.075 2.777 0 1.534-.926 2.778-2.075 2.778-1.143 0-2.075-1.244-2.075-2.778z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  strokeMiterlimit: 8,
  fill: "none",
  stroke: "#002060"
}, React.createElement("path", {
  d: "M50.472 13.562c-.027 5.89.025 13.44 0 19.33 0 1.453-1.287 2.626-2.878 2.626H7.41c-1.585 0-2.877-1.172-2.877-2.625V11.16c0-1.45 1.293-2.627 2.878-2.627h28.07",
  strokeWidth: 0.80000001
}), React.createElement("path", {
  d: "M4.58 14.486h26.91",
  strokeWidth: 0.79999995
}));
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.937 8.456c0-1.382.728-2.508 1.618-2.508.894 0 1.62 1.126 1.62 2.508 0 1.385-.726 2.507-1.62 2.507-.89 0-1.618-1.122-1.618-2.507z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.473 8.47c0-1.63.918-2.962 2.04-2.962 1.125 0 2.038 1.33 2.038 2.963 0 1.64-.91 2.966-2.037 2.966-1.12 0-2.04-1.327-2.04-2.964M37 8c.12-1.395 1-2.403 1.48-2.486.52-.103 1.116.05 1.52.486",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001,
  strokeMiterlimit: 8,
  className: "icon-tertiary"
});
var _ref8 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001
}, React.createElement("path", {
  d: "M31.462 18.567h-1.95v4.955h5.012v-3.066M29.51 26.52h4.985v4.983H29.51zm10.02 0h4.983v4.983H39.53z"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "M19.518 18.54h4.984v4.982h-4.984zm-9.983 0h4.984v4.982H9.533z"
}), React.createElement("path", {
  d: "M9.47 26.52h4.983v4.983H9.47zm10.048 0h4.984v4.983h-4.984zM39.56 20v3.522h4.953V18.51h-1.15"
}));
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M40.062 17.52l-4.564.77-1.48-1.912 1.833-4.206.07-.053zm9.624-15.96l.844-.647c.844-.61 2.084-.497 2.57.064.722.946 1.448 1.892 2.175 2.838.188.23.252.56.226.92-.052.587-.37 1.24-.83 1.58l-.84.647z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M35.498 18.29l-1.11.188c-.787.1-1.155-.374-.82-1.07l.45-1.03zm.423-6.17L49.688 1.56l4.14 5.402-13.764 10.56z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref1 = /*#__PURE__*/React.createElement("g", {
  strokeMiterlimit: 10,
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000031,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M35.498 18.29l-1.11.188c-.787.1-1.155-.374-.82-1.07l.45-1.03"
}), React.createElement("path", {
  d: "M40.062 17.52l-4.564.77-1.48-1.912 1.833-4.206.07-.053M49.688 1.56l.844-.647c.845-.61 2.085-.497 2.57.064.723.946 1.45 1.892 2.176 2.838.188.23.252.56.226.92-.053.587-.37 1.24-.83 1.58l-.842.647"
}), React.createElement("path", {
  d: "M35.92 12.12L49.687 1.56l4.14 5.402-13.764 10.56z"
}));
var SvgMenuDefinesurvey = function SvgMenuDefinesurvey(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuDefinesurvey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu-definesurvey.913256ea.svg";
export { ForwardRef as ReactComponent };